<template>
    <div>
        <div v-if="ready" class="d-flex justify-content-end mb-3">
            <button @click="handleImprimir" class="btn btn-dark dashboard-action-btn">
                Generar Excel <i class="fa-solid fa-download ms-1"></i>
            </button>
        </div>

        <div class="table-wrapper">
            <table class="table table-hover align-middle mb-0 bitacora-table" id="myTable">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th class="text-center">Beneficiario</th>
                        <th>Comentario</th>
                        <th>Tipo Gestión</th>
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody v-if="ready && hasBitacoraRecords">
                    <tr v-for="actividad in bitacora" :key="actividad.id">
                        <td><span class="id-badge">#{{ actividad.id }}</span></td>
                        <td class="fw-semibold">{{ actividad.cliente }}</td>
                        <td>
                            <div class="comment-cell">
                                {{ actividad.comentario }}
                            </div>
                        </td>
                        <td><span class="tipo-badge">{{ actividad.tipoGestion }}</span></td>
                        <td>{{ actividad.nombreUsuario }}</td>
                    </tr>
                </tbody>
                <tbody v-else-if="ready && !hasBitacoraRecords">
                    <tr>
                        <td colspan="5" class="text-center py-4 empty-state">
                            <i class="fa-regular fa-folder-open me-2"></i>
                            No se encontraron registros para el rango seleccionado.
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="5" class="text-center py-4">
                            <div class="spinner-border text-warning text-center" role="status">
                                <span class="visually-hidden text-center">Loading...</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";
import DataTables from "datatables.net";
import ExcelJS from "exceljs";


export default {
    data() {
        return {
            ready: false,
            bitacora: [],
            moneda: "lps",
            imgPath: process.env.VUE_APP_IMAGE_URL,
            totalMontoPagado: 0,
            dataTable: null,
            pago: {
                slug: ''
            }
        }
    },
    props: {
        startDate: new Date,
        endDate: new Date,
        option: Boolean,
    },
    watch: {
        startDate: function () {
            this.getBitacoraByRange()
        },
        endDate: function () {
            this.getBitacoraByRange()
        }
    },
    beforeMount() {

        this.getBitacoraByRange()
    },
    beforeUnmount() {
        this.destroyDataTable();
    },
    updated() {
        if (this.ready && this.hasBitacoraRecords) {
            this.initializeDataTable();
        } else {
            this.destroyDataTable();
        }


    },
    computed: {
        hasBitacoraRecords() {
            return Array.isArray(this.bitacora) && this.bitacora.length > 0;
        }
    },
    methods: {

        getBitacoraByRange() {
            this.ready = false
            this.destroyDataTable();

            let payload = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            fetch(process.env.VUE_APP_API_URL + `/admin/bitocara/allByRange`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {

                        this.bitacora = Array.isArray(response?.data?.bitacora) ? response.data.bitacora : [];
                        this.ready = true
                        console.log('Bitacora:', response);

                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },

        initializeDataTable() {
            const myTable = document.querySelector("#myTable");
            if (myTable && !this.dataTable) {
                this.dataTable = new DataTables(myTable, {
                    language: {
                        lengthMenu: "Mostrar _MENU_ registros",
                        search: "Buscar:",
                        info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        infoEmpty: "Mostrando 0 a 0 de 0 registros",
                        infoFiltered: "(filtrado de _MAX_ registros totales)",
                        zeroRecords: "No se encontraron resultados",
                        emptyTable: "No hay datos disponibles en la tabla",
                        paginate: {
                            first: "Primero",
                            previous: "Anterior",
                            next: "Siguiente",
                            last: "Último"
                        }
                    }
                });
            }


        },

        destroyDataTable() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },

        dateFormat(param) {

            var fechaISO = param;

            var fecha = new Date(fechaISO);

            var dia = ('0' + fecha.getUTCDate()).slice(-2);

            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

            var anio = fecha.getUTCFullYear();

            var fechaFormateada = dia + '/' + mes + '/' + anio;


            return fechaFormateada;

        },
        pagoSlug(slug) {
            this.pago.slug = slug
        },

        handleImprimir() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Bitácora");

            worksheet.columns = [
                { header: "ID", key: "id", width: 10 },
                { header: "Beneficiario", key: "cliente", width: 30 },
                { header: "DNI", key: "dni", width: 20 },
                { header: "Comentario", key: "comentario", width: 60 },
                { header: "Tipo Gestión", key: "tipoGestion", width: 20 },
                { header: "No Préstamo", key: "noPrestamo", width: 20 },
                { header: "Fecha Promesa", key: "fechaPromesa", width: 20 },
                { header: "Monto Promesa", key: "montoPromesa", width: 20 },
                { header: "Creado por:", key: "usuario", width: 20 },
                { header: "Fecha Creación", key: "creado", width: 20 },
            ];

            worksheet.getRow(1).font = { bold: true };

            const data = this.bitacora.map((item) => ({
                id: item.id,
                cliente: item.cliente,
                dni: item.dni,
                comentario: item.comentario,
                tipoGestion: item.tipoGestion,
                noPrestamo: item.noPrestamo,
                fechaPromesa: this.dateFormat(item.fechaPromesa),
                montoPromesa: item.montoPromesa,
                usuario: item.nombreUsuario,

                creado: this.dateFormat(item.createdAt),
            }));

            worksheet.addRows(data);

            worksheet.getColumn('fechaPromesa').numFmt = 'dd/mm/yyyy';

            worksheet.addTable({
                name: 'BitacoraTable',
                ref: 'A1',
                headerRow: true,
                style: {
                    theme: 'TableStyleMedium2',
                    showRowStripes: true,
                },
                columns: worksheet.columns.map(col => ({ name: col.header, filterButton: true })),
                rows: data.map(row => worksheet.columns.map(col => row[col.key])),
            });

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", `Bitacora-${this.dateFormat(this.startDate)}-${this.dateFormat(this.endDate)}.xlsx`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        }


    },

}
</script>

<style scoped>
.table-wrapper {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.bitacora-table {
    min-width: 1000px;
}

.bitacora-table thead th {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #475569;
    font-weight: 700;
}

.bitacora-table tbody tr {
    transition: background-color 0.2s ease;
}

.bitacora-table tbody tr:hover {
    background-color: #f8fafc;
}

.comment-cell {
    white-space: normal;
    word-break: break-word;
    max-width: 380px;
    text-align: justify;
    color: #334155;
}

.id-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: #e2e8f0;
    color: #0f172a;
    font-weight: 600;
    font-size: 0.8rem;
}

.tipo-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: #eef2ff;
    color: #3730a3;
    font-size: 0.8rem;
    font-weight: 600;
}

.empty-state {
    color: #64748b;
}

.dashboard-action-btn {
    border-radius: 12px;
    padding: 0.62rem 1rem;
    font-weight: 600;
    background: #111827 !important;
    border-color: #111827 !important;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.25);
}

.dashboard-action-btn:hover {
    background: #1f2937 !important;
    border-color: #1f2937 !important;
}


:deep(.dt-layout-row .dt-layout-start),
:deep(.dt-layout-row .dt-layout-end) {
    display: flex;
    justify-content: center;
}

:deep(.dt-length),
:deep(.dt-info),
:deep(.dataTables_length),
:deep(.dataTables_info) {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    text-align: center !important;
    margin-top: 8px !important;
}

:deep(.dt-length label),
:deep(.dt-info),
:deep(.dataTables_length label),
:deep(.dataTables_info) {
    margin-bottom: 0;
}

td {
    vertical-align: middle;
}
</style>
